"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _noSidebar = _interopRequireDefault(require("./noSidebar.png"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = {
  handle: 'noSidebar',
  label: 'Default',
  thumbnail: _noSidebar["default"]
};